<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.backdropBlur" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="backdropBlur" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.fullScreenLabel" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="fullScreen" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.persistent" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="persistent" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.modal" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="modal" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dismissButton" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dismissButton" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.icon" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="icon" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <container align="center">
          <btn @click="dialog = true" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" icon-left="application">{{ $lang.showDialog }}</btn>
        </container>
        <dialog-box
          @dismiss="log('dismiss', 'dialog', null)"
          @icon-click="log('icon-click', 'dialog-icon', null)"
          @icon-dblclick="log('icon-dblclick', 'dialog-icon', $event)"
          v-model="dialog"
          title="Dialog Box"
          max-width="40%"
          :backdrop-blur="backdropBlur"
          :icon="icon ? 'account' : null"
          :modal="modal"
          :full-screen="fullScreen"
          :persistent="persistent"
          :title-bg-color="$root.colors.primary"
          :title-bg-color-lightness="$root.colors.bgColorLightness"
          :dismiss-button="dismissButton">
          <template v-slot:content>
            <lorem-ipsum :repeats="2" />
          </template>
          <template v-slot:actions>
            <btn plain :color="$root.colors.primary" :color-lightness="$root.colors.bgColorLightness" @click="dialog = false">{{ $lang.cancel }}</btn>
            <btn :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" @click="dialog = false" color="white">{{ $lang.ok }}</btn>
          </template>
        </dialog-box>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageDialogBox',
  mixins: [
    methods
  ],
  data () {
    return {
      dialog: false,
      fullScreen: false,
      persistent: true,
      modal: true,
      dismissButton: true,
      icon: true,
      backdropBlur: false
    }
  },
  watch: {
    backdropBlur () {
      if (this.backdropBlur) {
        this.modal = true
      }
    },
    modal () {
      if (!this.modal) {
        this.backdropBlur = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/dialog-box.vue